<template>
  <div>
    <v-btn color="primary" dark class="mt-4 mb-3 ml-1" @click="newItem">+</v-btn>
    <v-dialog v-model="ItemDialog" max-width="800px">
      <v-card>
        <v-card-title>
          {{ subDialogTitle }} <v-spacer></v-spacer><span class="page_title_value" v-if="subDialog">{{
            subDialogTitleValue }}</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <div v-if="isExercisepo">
            <v-row>
              <v-col cols="8" sm="5" md="8">
                <v-autocomplete outlined :label="this.$t('arrearsexercise.payout')" type="text" clearable :items="payoutsList"
                  v-model="exercisepo.id" @change="changeValueHandler(exercisepo.id)" dense></v-autocomplete>
              </v-col>

              <v-col cols="8" sm="5" md="4">
                <v-text-field outlined :label="this.$t('columns.code')" type="text" v-model="exercisepo.payoutcode"
                  dense readonly background-color="#ffeab2"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="8" sm="5" md="3" class="mt-n8">
                <v-text-field outlined :label="this.$t('arrearsexercise.pyyear')" type="text" v-model="exercisepo.pyyear" dense readonly
                  background-color="#ffeab2"></v-text-field>
              </v-col>
              <v-col cols="8" sm="5" md="3" class="mt-n8">
                <v-text-field outlined :label="this.$t('arrearsexercise.pymonth')" type="text" v-model="exercisepo.pymonth" dense
                  readonly background-color="#ffeab2"></v-text-field>
              </v-col>
              <v-col cols="8" sm="5" md="3" class="mt-n8">
                <v-text-field outlined :label="this.$t('columns.startdate')" type="date" v-model="exercisepo.startdate"
                  dense readonly background-color="#ffeab2"></v-text-field>
              </v-col>
              <v-col cols="8" sm="5" md="3" class="mt-n8">
                <v-text-field outlined :label="this.$t('columns.enddate')" type="date" v-model="exercisepo.enddate"
                  dense readonly background-color="#ffeab2"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="8" sm="5" md="8" class="mt-n8">
                <v-text-field outlined :label="this.$t('payrollprocessrun.payrollgroup')" type="text"
                  v-model="exercisepo.valvaluedesc" dense readonly background-color="#ffeab2"></v-text-field>
              </v-col>

              <v-col cols="8" sm="5" md="4" class="mt-n8">
                <v-text-field outlined :label="this.$t('columns.code')" type="text" v-model="exercisepo.grouppdesc"
                  dense readonly background-color="#ffeab2"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="8" sm="5" md="8" class="mt-n8">
                <v-text-field outlined :label="this.$t('setuppayrolltype.payrolltype')" type="text"
                  v-model="exercisepo.payrolltypedesc" dense readonly background-color="#ffeab2"></v-text-field>
              </v-col>

              <v-col cols="8" sm="5" md="4" class="mt-n8">
                <v-text-field outlined :label="this.$t('columns.code')" type="text" v-model="exercisepo.payrolltypecode"
                  dense readonly background-color="#ffeab2"></v-text-field>
              </v-col>
            </v-row>
            </div>

            <div v-if="isExercisepayitem">
            <v-row>
              <v-col cols="8" sm="5" md="8">
                <v-autocomplete outlined :label="this.$t('payrollenquiryreport.payitemtypecategory')" type="text" clearable
                  :items="payItemCatList" v-model="exercisepayitem.oripayitemcatid"
                  @change="changePayItemCatHandler(exercisepayitem.oripayitemcatid)" dense></v-autocomplete>
              </v-col>

              <v-col cols="8" sm="5" md="4">
                <v-text-field outlined :label="this.$t('columns.code')" type="text"
                  v-model="exercisepayitem.oripayitemcatcode" dense readonly background-color="#ffeab2"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="8" sm="5" md="8" class="mt-n8">
                <v-autocomplete outlined :label="this.$t('arrearsexercise.topaypayitem')" type="text" clearable :items="payItemList"
                  v-model="exercisepayitem.topaypayitemid"
                  @change="changePayitemHandler(exercisepayitem.topaypayitemid)" dense></v-autocomplete>
              </v-col>

              <v-col cols="8" sm="5" md="4" class="mt-n8">
                <v-text-field outlined :label="this.$t('columns.code')" type="text"
                  v-model="exercisepayitem.topaypayitemcode" dense readonly background-color="#ffeab2"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="8" sm="5" md="8" class="mt-n8">
                <v-autocomplete outlined :label="this.$t('arrearsexercise.todedtpayitem')" type="text" clearable :items="payItemList"
                  v-model="exercisepayitem.todedtpayitemid"
                  @change="changeDedtPayitemHandler(exercisepayitem.todedtpayitemid)" dense></v-autocomplete>
              </v-col>

              <v-col cols="8" sm="5" md="4" class="mt-n8">
                <v-text-field outlined :label="this.$t('columns.code')" type="text"
                  v-model="exercisepayitem.todedtpayitemcode" dense readonly background-color="#ffeab2"></v-text-field>
              </v-col>
            </v-row>
            </div>

            <div v-if="isExercisestatpayitem">
            <v-row>
              <v-col cols="8" sm="5" md="8">
                <v-autocomplete outlined :label="this.$t('arrearsexercise.topaypayitem')" type="text" clearable
                  :items="statPayItemList" v-model="exercisestatpayitem.oripayitemid"
                  @change="changeStatOriPayitemHandler(exercisestatpayitem.oripayitemid)" dense></v-autocomplete>
              </v-col>

              <v-col cols="8" sm="5" md="4">
                <v-text-field outlined :label="this.$t('columns.code')" type="text"
                  v-model="exercisestatpayitem.oripayitemcode" dense readonly background-color="#ffeab2"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="8" sm="5" md="8" class="mt-n8">
                <v-autocomplete outlined :label="this.$t('arrearsexercise.todedtpayitem')" type="text" clearable :items="statDedtPayItemList"
                  v-model="exercisestatpayitem.topaypayitemid"
                  @change="changeStatToPayitemHandler(exercisestatpayitem.topaypayitemid)" dense></v-autocomplete>
              </v-col>

              <v-col cols="8" sm="5" md="4" class="mt-n8">
                <v-text-field outlined :label="this.$t('columns.code')" type="text"
                  v-model="exercisestatpayitem.topaypayitemcode" dense readonly background-color="#ffeab2"></v-text-field>
              </v-col>
            </v-row>
            </div>

          </v-container>
        </v-card-text>

        <!-- <v-card-text v-if="isErr" class="mt-n12">
          <span style="font-weight: bold; color: red">{{
            errMsg
          }}</span>
        </v-card-text> -->

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="closeCRUD">{{ $t('button.cancel') }}</v-btn>

          <v-btn color="green darken-1" text @click="saveItems">{{ $t('button.save') }}</v-btn>

          <!-- <v-btn
                      v-else
                      disabled
                      color="green darken-1"
                      text
                      @click="saveItems"
                      >Save</v-btn> -->

        </v-card-actions>
      </v-card>
    </v-dialog>

    <div style="overflow-x: auto; width: 100%;">
        <v-data-table :headers="this.parentObject.tabHeader" :items="this.detailItem" class="elavation-1"
:sort-by="['code']">
      <template v-slot:item.action="{ item }">
        <v-icon small class="mr-2" @click="modifyItemHandler(item)">
          mdi-pen
        </v-icon>
        <v-icon small class="ml-2 mt-n2 mr-2" @click="deleteItemHandler(item)">
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
        </div>

    <div v-if="isErr">
      <app-error v-bind:parentError="{
        data: this.errMsg,
        isErr: this.isErr,
      }" v-on:closeError="isErr = $event" />
    </div>
    <div v-if="isSuccess">
      <app-success v-bind:parentObject="{
        isSuccess: this.isSuccess,
        messageSuccess: this.messageSuccess,
      }" />
    </div>
    <div v-if="isConfirm">
      <app-confirm v-bind:parentObject="{
        messageConfirm: this.messageConfirm,
        isConfirm: this.isConfirm,
      }" v-on:cancelConfirm="isConfirm = !isConfirm" />
    </div>
  </div>
</template>

<script>
import compareArray from "../../../util/comparearray";
import ErrorDialog from "../../../components/common/ErrorDialog";
import moment from "moment";

export default {
  props: {
    parentObject: Object,
  },

  components: {
    "app-error": ErrorDialog
  },

  data() {
    return {
      rules: {
        required: value => !!value || this.$t('reportsparam.required'),
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || this.$t('reportsparam.invalidemail');
        }
      },

      ItemDialog: false,
      formTitle: this.parentObject.formTitle,
      formId: this.parentObject.formId,
      subDialogTitle: "",
      subDialogTitleValue: "",
      detailItem: this.parentObject.detailItem,
      isExercisepo: false,
      exercisepo: {
        id: null,
        payoutcode: null,
        payoutdesc: null,
        pyyear: null,
        pymonth: null,
        startdate: null,
        enddate: null,
        grouppdesc: null,
        valvaluedesc: null,
        payrolltypecode: null,
        payrolltypedesc: null,

        updatedby: this.$store.getters.userId,
        action: 0,
      },
      isExercisepayitem: false,
      exercisepayitem: {
        id: null,
        oripayitemcatid: null,
        oripayitemcatcode: null,
        oripayitemcatdesc: null,
        topaypayitemid: null,
        topaypayitemcode: null,
        topaypayitemdesc: null,
        todedtpayitemid: null,
        todedtpayitemcode: null,
        todedtpayitemdesc: null,

        updatedby: this.$store.getters.userId,
        action: 0,
      },

      isExercisestatpayitem: false,
      exercisestatpayitem: {
        id: null,
        oripayitemid: null,
        oripayitemcode: null,
        oripayitemdesc: null,
        topaypayitemid: null,
        topaypayitemcode: null,
        topaypayitemdesc: null,

        updatedby: this.$store.getters.userId,
        action: 0,
      },

      payoutsList: [],
      payouts: [],

      payItemCats: [],
      payItemCatList: [],

      payItems: [],
      payItemList: [],

      statPayItems: [],
      statPayItemList: [],
      statDedtPayItemList: [],

      subDialog: false,
      modify: false,
      existingId: null,
      isConfirm: false,

      isNew: false,
      // isConfirm: false,
      confirmDelete: false,
      isSuccess: false,

      isExisting: false,
      isErr: false,
      errMsg: "",
    };
  },
  watch: {
  },
  methods: {

    compareArray,

newItem() {
    this.isExisting = false;
    this.modify = false;
    this.changeSubDialogTitleCreate();
    this.openDialog();
},

    changeSubDialogTitleCreate() {
      this.subDialogTitle = this.formTitle;
      this.subDialogTitleValue = null;

      if (this.formId == "exercisepo") {
        this.resetExercisepo();
        this.isExercisepo = true;
      } else if (this.formId == "exercisepayitem") {
        this.resetExercisepayitem();
        this.isExercisepayitem = true;
      } else if (this.formId == "exercisestatpayitem") {
        this.resetExercisestatpayitem();
        this.isExercisestatpayitem = true;
      }
    },

    modifyItemHandler(item) {

      this.isExisting = true;
      if (item.action == 1) {
        this.modify = true;
      }

      if (this.formId == "exercisepo") {
        this.isExercisepo = true;
        this.id = item.id;
        this.existingId = item.oripoid;
        this.exercisepo = {
          id: item.oripoid,
          payoutcode: item.oripocode,
          payoutdesc: item.oripodesc,
          pyyear: item.oripoyear,
          pymonth: item.oripomth,
          startdate: item.oripostartdate,
          enddate: item.oripoenddate,
          grouppdesc: item.oripopygroupcode,
          valvaluedesc: item.oripopygroupdesc,
          payrolltypecode: item.oripopytypecode,
          payrolltypedesc: item.oripopytypedesc,
          action: item.action == 0 ? item.action : 1
        };
      } else if (this.formId == "exercisepayitem") {
        this.isExercisepayitem = true;
        this.id = item.id;
        this.existingId = item.oripayitemcatid;
        this.exercisepayitem = {
          id: item.id,
          oripayitemcatid: item.oripayitemcatid,
          oripayitemcatcode: item.oripayitemcatcode,
          oripayitemcatdesc: item.oripayitemcatdesc,
          topaypayitemid: item.topaypayitemid,
          topaypayitemcode: item.topaypayitemcode,
          topaypayitemdesc: item.topaypayitemdesc,
          todedtpayitemid: item.todedtpayitemid,
          todedtpayitemcode: item.todedtpayitemcode,
          todedtpayitemdesc: item.todedtpayitemdesc,
          action: item.action == 0 ? item.action : 1
        }
      } else if (this.formId == "exercisestatpayitem") {
        this.isExercisestatpayitem = true;
        this.id = item.id;
        this.existingId = item.oripayitemid + '-' + item.topaypayitemid;
        this.exercisestatpayitem = {
          id: item.id,
          oripayitemid: item.oripayitemid,
          oripayitemcode: item.oripayitemcode,
          oripayitemdesc: item.oripayitemdesc,
          topaypayitemid: item.topaypayitemid,
          topaypayitemcode: item.topaypayitemcode,
          topaypayitemdesc: item.topaypayitemdesc,
          action: item.action == 0 ? item.action : 1
        }
      }

      this.openDialog();
    },

    deleteItemHandler(item) {
      let itemIndex = this.detailItem.indexOf(item);
      this.detailItem.splice(itemIndex, 1);
      return true
    },

    openDialog() {

      this.ItemDialog = true;
    },

    closeCRUD() {

      this.resetExercisepo();
      this.resetExercisepayitem();
      this.resetExercisestatpayitem();

      this.ItemDialog = false;
      this.isErr = false;
      this.isExisting = false;
      this.modify = false;
      this.existingId = null;

      this.detailItem = [...this.detailItem];
    },

    async saveItems() {
      const vm = this;
      if (vm.formId == "exercisepo") {
        if (vm.detailItem.find(e => e.oripoid === vm.exercisepo.id && e.oripoid != vm.existingId)) {
          vm.isErr = true;
          vm.errMsg = "Duplicate not allowed";
        } else {
          if (vm.exercisepo.id == null) {
            vm.$dialog.alert(vm.$t('fillinrequirefields')).then((dialog) => {
              console.log(dialog);
            });
          } else {

            if (vm.modify || vm.isExisting) {
              vm.detailItem.forEach(e => {
                if (e.oripoid == vm.existingId) {
                  (e.oripoid = vm.exercisepo.id),
                    (e.oripocode = vm.exercisepo.payoutcode),
                    (e.oripodesc = vm.exercisepo.payoutdesc),
                    (e.oripoyear = vm.exercisepo.pyyear),
                    (e.oripomth = vm.exercisepo.pymonth),
                    (e.oripostartdate = vm.exercisepo.startdate),
                    (e.oripoenddate = vm.exercisepo.enddate),
                    (e.oripopytypecode = vm.exercisepo.payrolltypecode),
                    (e.oripopytypedesc = vm.exercisepo.payrolltypedesc),
                    (e.oripopygroupcode = vm.exercisepo.grouppdesc),
                    (e.oripopygroupdesc = vm.exercisepo.valvaluedesc),
                    (e.action = vm.modify ? 2 : 0)
                }
              });
            } else {
              vm.detailItem.push(
                {
                  id: vm.exercisepo.id,
                  oripoid: vm.exercisepo.id,
                  oripocode: vm.exercisepo.payoutcode,
                  oripodesc: vm.exercisepo.payoutdesc,
                  oripoyear: vm.exercisepo.pyyear,
                  oripomth: vm.exercisepo.pymonth,
                  oripostartdate: vm.exercisepo.startdate,
                  oripoenddate: vm.exercisepo.enddate,
                  oripopytypecode: vm.exercisepo.payrolltypecode,
                  oripopytypedesc: vm.exercisepo.payrolltypedesc,
                  oripopygroupcode: vm.exercisepo.grouppdesc,
                  oripopygroupdesc: vm.exercisepo.valvaluedesc,
                  action: 0
                }
              );
            }
            vm.$emit("input", vm.detailItem);
            vm.closeCRUD();
          }
        }
      } else if (vm.formId == "exercisepayitem") {
        if (vm.detailItem.find(e => e.oripayitemcatid === vm.exercisepayitem.oripayitemcatid
        && (e.id != vm.exercisepayitem.id || vm.existingId != e.oripayitemcatid))) {
          vm.isErr = true;
          vm.errMsg = "This category has already been added. Duplicate categories are not allowed.";
        } else {
          if (vm.exercisepayitem.oripayitemcatid == null || vm.exercisepayitem.topaypayitemid == null || vm.exercisepayitem.todedtpayitemid == null) {
            vm.$dialog.alert(vm.$t('fillinrequirefields')).then((dialog) => {
              console.log(dialog);
            });
          } else {

            if (vm.modify || vm.isExisting) {
              vm.detailItem.forEach(e => {
                if (e.id == vm.id && vm.existingId == e.oripayitemcatid) {
                  (e.oripayitemcatid = vm.exercisepayitem.oripayitemcatid),
                    (e.oripayitemcatcode = vm.exercisepayitem.oripayitemcatcode),
                    (e.oripayitemcatdesc = vm.exercisepayitem.oripayitemcatdesc),
                    (e.topaypayitemid = vm.exercisepayitem.topaypayitemid),
                    (e.topaypayitemcode = vm.exercisepayitem.topaypayitemcode),
                    (e.topaypayitemdesc = vm.exercisepayitem.topaypayitemdesc),
                    (e.todedtpayitemid = vm.exercisepayitem.todedtpayitemid),
                    (e.todedtpayitemcode = vm.exercisepayitem.todedtpayitemcode),
                    (e.todedtpayitemdesc = vm.exercisepayitem.todedtpayitemdesc),
                    (e.action = vm.modify ? 2 : 0)
                }
              });
            } else {
              vm.detailItem.push(
                {
                  id: vm.exercisepayitem.id,
                  oripayitemcatid: vm.exercisepayitem.oripayitemcatid,
                  oripayitemcatcode: vm.exercisepayitem.oripayitemcatcode,
                  oripayitemcatdesc: vm.exercisepayitem.oripayitemcatdesc,
                  topaypayitemid: vm.exercisepayitem.topaypayitemid,
                  topaypayitemcode: vm.exercisepayitem.topaypayitemcode,
                  topaypayitemdesc: vm.exercisepayitem.topaypayitemdesc,
                  todedtpayitemid: vm.exercisepayitem.todedtpayitemid,
                  todedtpayitemcode: vm.exercisepayitem.todedtpayitemcode,
                  todedtpayitemdesc: vm.exercisepayitem.todedtpayitemdesc,
                  action: 0
                }
              );
            }
            vm.$emit("input", vm.detailItem);
            vm.closeCRUD();
          }
        }
      } else if (vm.formId == "exercisestatpayitem") {
        if (vm.detailItem.find(e => e.oripayitemid === vm.exercisestatpayitem.oripayitemid
        && e.topaypayitemid === vm.exercisestatpayitem.topaypayitemid
        && (e.id != vm.exercisestatpayitem.id || vm.existingId != (e.oripayitemid + '-' + e.topaypayitemid)))) {
          vm.isErr = true;
          vm.errMsg = "Duplicate not allowed";
        } else {
          if (vm.exercisestatpayitem.oripayitemid == null || vm.exercisestatpayitem.topaypayitemid == null) {
            vm.$dialog.alert(vm.$t('fillinrequirefields')).then((dialog) => {
              console.log(dialog);
            });
          } else {
            if (vm.modify || vm.isExisting) {
              vm.detailItem.forEach(e => {
                if (e.id == vm.id && vm.existingId == (e.oripayitemid + '-' + e.topaypayitemid)) {
                  (e.oripayitemid = vm.exercisestatpayitem.oripayitemid),
                    (e.oripayitemcode = vm.exercisestatpayitem.oripayitemcode),
                    (e.oripayitemdesc = vm.exercisestatpayitem.oripayitemdesc),
                    (e.topaypayitemid = vm.exercisestatpayitem.topaypayitemid),
                    (e.topaypayitemcode = vm.exercisestatpayitem.topaypayitemcode),
                    (e.topaypayitemdesc = vm.exercisestatpayitem.topaypayitemdesc),
                    (e.action = vm.modify ? 2 : 0)
                }
              });
            } else {
              vm.detailItem.push(
                {
                  id: vm.exercisestatpayitem.id,
                  oripayitemid: vm.exercisestatpayitem.oripayitemid,
                  oripayitemcode: vm.exercisestatpayitem.oripayitemcode,
                  oripayitemdesc: vm.exercisestatpayitem.oripayitemdesc,
                  topaypayitemid: vm.exercisestatpayitem.topaypayitemid,
                  topaypayitemcode: vm.exercisestatpayitem.topaypayitemcode,
                  topaypayitemdesc: vm.exercisestatpayitem.topaypayitemdesc,
                  action: 0
                }
              );
            }
            vm.$emit("input", vm.detailItem);
            vm.closeCRUD();
          }
        }
      }
    },

    resetExercisepo() {
      this.exercisepo =
      {
        id: null,
        payoutdesc: null,
        payoutcode: null,
        pyyear: null,
        pymonth: null,
        startdate: null,
        enddate: null,
        grouppdesc: null,
        valvaluedesc: null,
        payrolltypecode: null,
        payrolltypedesc: null,
        rectimestamp: null,
        updatedby: this.$store.getters.userId,
        stamp: 0,
        action: 0
      };
    },    
    resetExercisepayitem() {
      this.exercisepayitem = {
          id: null,
          oripayitemcatid: null,
          oripayitemcatcode: null,
          oripayitemcatdesc: null,
          topaypayitemid: null,
          topaypayitemcode: null,
          topaypayitemdesc: null,
          todedtpayitemid: null,
          todedtpayitemcode: null,
          todedtpayitemdesc: null,
          rectimestamp: null,
          updatedby: this.$store.getters.userId,
          stamp: 0,
          action: 0
        }
    },
    resetExercisestatpayitem() {
      this.exercisestatpayitem = {
          id: null,
          oripayitemid: null,
          oripayitemcode: null,
          oripayitemdesc: null,
          topaypayitemid: null,
          topaypayitemcode: null,
          topaypayitemdesc: null,
          rectimestamp: null,
          updatedby: this.$store.getters.userId,
          stamp: 0,
          action: 0
        }
    },
    loadValueListHandler() {
      const vm = this;
      this.$store.dispatch('get', { url: '/payoutctrl/all' })
        .then((res) => {
          vm.payouts = res.data.rec;

          for (let i = 0; i < res.data.rec.length; i++) {
            vm.payoutsList.push({
              text: res.data.rec[i].payoutdesc,
              value: res.data.rec[i].id,
            });
          }
        })
        .catch((err) => {
          vm.isErr = true;
          vm.errMsg = err;
          vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
        });
    },
    changeValueHandler(id) {
      let item = this.payouts.find((item) => item.id === id);
      this.exercisepo.payoutdesc = item.payoutdesc;
      this.exercisepo.payoutcode = item.payoutcode;
      this.exercisepo.pyyear = item.pyyear;
      this.exercisepo.pymonth = item.pymonth;
      this.exercisepo.startdate = moment(item.startdate).format("YYYY-MM-DD");
      this.exercisepo.enddate = moment(item.enddate).format("YYYY-MM-DD");
      this.exercisepo.grouppdesc = item.grouppdesc;
      this.exercisepo.valvaluedesc = item.valvaluedesc;
      this.exercisepo.payrolltypecode = item.payrolltypecode;
      this.exercisepo.payrolltypedesc = item.payrolltypedesc;
    },

    loadPayItemCatListHandler() {
      const vm = this;

      this.$store.dispatch('get', { url: '/payitemcat/all' })
        .then(res => {
          vm.payItemCats = res.data.rec;

          for (let i = 0; i < res.data.rec.length; i++) {
            if (["BASIC", "BONUS", "OT", "ALLW", "DEDT", "NPAY"].includes(res.data.rec[i].payitemcatcode.toUpperCase())) {
              vm.payItemCatList.push({
                text: res.data.rec[i].payitemcatdesc,
                value: res.data.rec[i].id
              });
            }
          }

          if (vm.exercisepayitem.oripayitemcatid) {
            vm.changePayItemCatHandler(vm.exercisepayitem.oripayitemcatid);
          }
        })
        .catch(err => {
          vm.isErr = true;
          vm.errMsg = err;
          vm.$emit('error', { isErr: vm.isErr, errMsg: vm.errMsg });
        });
    },

    changePayItemCatHandler(id) {
      let item = this.payItemCats.find(item => item.id === id);
      this.exercisepayitem.oripayitemcatcode = item.payitemcatcode;
      this.exercisepayitem.oripayitemcatdesc = item.payitemcatdesc;
    },

    loadPayItem() {
      const vm = this;

      this.$store.dispatch('get', {
        url: "/payitems/all"
      }).then((res) => {
        vm.payItems = res.data.rec;

        for (let i = 0; i < vm.payItems.length; i++) {
          if (["BASIC", "BONUS", "OT", "ALLW", "DEDT", "NPAY"].includes(vm.payItems[i].payitemcatcode.toUpperCase())) {
            vm.payItemList.push({
              text: vm.payItems[i].payitemdesc,
              value: vm.payItems[i].id,
            });
          }
        }
      });
    },
    loadStatPayItem() {
      const vm = this;

      this.$store.dispatch('get', {
        url: "/proclistmasd/5"
      }).then((res) => {
        vm.statPayItems = res.data.rec;
        
        for (let i = 0; i < vm.statPayItems.length; i++) {
          if (!vm.statPayItems[i].payitemdesc.toUpperCase().includes("ARREARS")) {
            vm.statPayItemList.push({
              text: vm.statPayItems[i].payitemdesc,
              value: vm.statPayItems[i].payitemid,
            });
          } 
        }
        for (let i = 0; i < vm.statPayItems.length; i++) {
          vm.statDedtPayItemList.push({
             text: vm.statPayItems[i].payitemdesc,
             value: vm.statPayItems[i].payitemid,
          });
        }
      });
    },
    changePayitemHandler(id) {
      let item = this.payItems.find((item) => item.id === id);
      this.exercisepayitem.topaypayitemid = item.id;
      this.exercisepayitem.topaypayitemcode = item.payitemcode;
      this.exercisepayitem.topaypayitemdesc = item.payitemdesc;
    },
    changeDedtPayitemHandler(id) {
      let item = this.payItems.find((item) => item.id === id);
      this.exercisepayitem.todedtpayitemid = item.id;
      this.exercisepayitem.todedtpayitemcode = item.payitemcode;
      this.exercisepayitem.todedtpayitemdesc = item.payitemdesc;
    },

    changeStatOriPayitemHandler(id) {
      let item = this.statPayItems.find((item) => item.payitemid === id);
      this.exercisestatpayitem.oripayitemid = item.payitemid;
      this.exercisestatpayitem.oripayitemcode = item.payitemcode;
      this.exercisestatpayitem.oripayitemdesc = item.payitemdesc;
    },

    changeStatToPayitemHandler(id) {
      let item = this.statPayItems.find((item) => item.payitemid === id);
      this.exercisestatpayitem.topaypayitemid = item.payitemid;
      this.exercisestatpayitem.topaypayitemcode = item.payitemcode;
      this.exercisestatpayitem.topaypayitemdesc = item.payitemdesc;
    },
  },

  created() {
    this.loadValueListHandler();
    this.loadPayItemCatListHandler();
    this.loadPayItem();
    this.loadStatPayItem();
  },
};
</script>